import NonEditableBlock from './base/non-editable-block';
import openingTag from '@intercom/embercom-composer/lib/computed-properties/ic-block-opening-tag';
import { computed } from '@ember/object';
import { fmt, hashWithoutNulls, htmlEscape } from '@intercom/pulse/lib/computed-properties';
import EntityList from '@intercom/embercom-composer/blocks/entities/entity-list';
import Em from 'ember';
let template = `
<a class="intercom-interblocks-link" data-link-type="educate.article" href="%@" target="_blank" rel="noreferrer nofollow noopener">
  <div class="intercom-interblocks-link-content-container">
    <div class="intercom-interblocks-link-title">%@</div>
    <div class="intercom-interblocks-link-description">%@</div>%@
  </div>
</a>`;
function authorTemplate(avatarUrl, authorName) {
  return `
    <div class="intercom-interblocks-link-author">
      <div class="intercom-interblocks-link-author-avatar">
        <img class="intercom-interblocks-link-author-avatar-image" src="${avatarUrl}">
      </div>
      <div class="intercom-interblocks-link-author-summary">
        <span class="intercom-interblocks-link-author-name">${authorName}</span>
      </div>
    </div>`;
}
export default NonEditableBlock.extend({
  allowedEntities: ['anchor'],
  isMedia: true,
  hasEditor: false,
  type: 'link',
  linkType: null,
  text: '',
  title: '',
  description: null,
  url: '',
  author: null,
  createdAt: null,
  updatedAt: null,
  escapedArticleId: htmlEscape('articleId'),
  escapedTitle: htmlEscape('title'),
  escapedDescription: htmlEscape('description'),
  escapedUrl: htmlEscape('url'),
  escapedAuthorName: htmlEscape('author.name'),
  escapedAvatarUrl: htmlEscape('author.avatar'),
  authorHtml: Em.computed(function () {
    if (this.get('author')) {
      return authorTemplate(this.get('escapedAvatarUrl'), this.get('escapedAuthorName'));
    }
    return '';
  }),
  class: 'card',
  openingTag: openingTag(),
  closingTag: '</ic-block>',
  innerHtml: computed('_zeroWidthSpace', '_paragraphInserter', 'cardHtml', function () {
    return `${this._zeroWidthSpace}${this._paragraphInserter}<span contenteditable="false">${this.cardHtml}</span>${this._paragraphInserter}${this._zeroWidthSpace}`;
  }),
  cardHtml: fmt(template, 'escapedUrl', 'escapedTitle', 'escapedDescription', 'authorHtml'),
  serialized: hashWithoutNulls('articleId', 'author', 'createdAt', 'description', 'linkType', 'text', 'title', 'type', 'updatedAt', 'url'),
  init() {
    if (Em.isEmpty(this.get('config'))) {
      throw new Error('Config is required when creating a block');
    }
    this.set('id', `block-${Em.guidFor(this)}`);
    this.set('entities', EntityList.create());
  }
});